import { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'


export const HealthMonitor:FC<SvgIconProps> = (props) => {

  return (
    <SvgIcon
      stroke="#13212F"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}


    >

        <path
          d="M8.9707 22H14.9707C19.9707 22 21.9707 20 21.9707 15V9C21.9707 4 19.9707 2 14.9707 2H8.9707C3.9707 2 1.9707 4 1.9707 9V15C1.9707 20 3.9707 22 8.9707 22Z"
          strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path
          d="M1.9707 12.7L7.9707 12.68C8.7207 12.68 9.5607 13.25 9.8407 13.95L10.9807 16.83C11.2407 17.48 11.6507 17.48 11.9107 16.83L14.2007 11.02C14.4207 10.46 14.8307 10.44 15.1107 10.97L16.1507 12.94C16.4607 13.53 17.2607 14.01 17.9207 14.01H21.9807"
          strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />

    </SvgIcon>
  )
}